import { Observable } from 'rxjs/Observable';
import {DtoLoginResult} from "../../app/shared/models/DtoLoginResult";

export abstract class UserApi {
    signIn: (
        username: string,
        password: string,
        rememberMe: boolean
    ) => Observable<DtoLoginResult>;
    signOut: () => Observable<any>;
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/fw/users/user-api.ts